import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import { Box } from "@mui/material";
import moment from "moment";
import LmsKitLabel from "../../../components/features/LmsKitLabel";
import ProgressTracker from "../../../components/common/ProgressTracker";
import SkeletonLoader from "../../../../utilites/SkeltonLoader";
import InBoundForm from "../../../../pages/appointment-details/InBoundForm";
import { getPatientDetailsById } from "../../../slices/QRCode";
import { setSlugs } from "../../../slices/help";
import { hasAuthority } from "../../../../utils/authorities";
import { fetchV2V, selectAllInitialSteps, selectCurrentCycle } from "../../../slices/common";
import MarkAsShippedForm from "../../../components/common/ProgressTracker/MarkAsShippedForm";
import { recieveLSM } from "../../../slices/logisticSlice";
import ChatModule from "../../Chat";
import { addPatientList, addPhaseList } from "../../../slices/chat";
import OutBondForm from "../OutBound/Form";
import BreadCrumb from "../../../../pages/breadcrumb/BreadCrumb"
import { urlToBackWithoutState } from "../../../../utilites/Common";
import { useReactToPrint } from 'react-to-print';
import QrPrintContent from './QrPrintContent'
import {capitalizeWords} from "../../../../utils/utils"

const excludedPaths = [
  "logistics-management/in-bound",
  "lsm-acceptance",
  "manufacturer",
  "qc",
  "qa",
];

const InBoundView = () => {
  const [loading] = React.useState(false);
  const { id } = useParams();
  const allInitialSteps = useSelector(selectAllInitialSteps)
  const currentCycle = useSelector(selectCurrentCycle)
  const dispatch = useDispatch();
  const [patientInfo, setPatientInfo] = useState({});
  const [patientData, setPatientData] = useState({});
  const [patientMedicalInfo, setPatientMedicalInfo] = useState({});
  const [printPatientInfo, setPrintPatientInfo] = useState({});
  const [bagCount, setBagCount] = useState(0);
  const [, setPrintCount] = useState(null);
  const [, setPrintSingleBag] = useState(null);
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState('');
  const qrRef = useRef(null);
  const [printData, setPrintData] = useState(null);
  const printContentRef = useRef(null);
  const [timeLineSkeletonLoading, setTimeLineSkeletonLoading] = useState(false);
  const LoginData = useSelector((state) => state.loginData);
  const bmr_permissions = LoginData?.bmr_permissions || [];
  const location = useLocation();
  const navigate = useNavigate();
  const role_slug = LoginData.role_slug;
  const printTimeoutRef = useRef(null);
  const [ids, setIds] = useState(id)
  const [breadCrumbArray] = useState(() =>
    urlToBackWithoutState(location.pathname, location?.state, undefined, navigate)
  );
   const [phaseType, setPhaseType] = useState('');
  const isCommercial = phaseType === "Commercial";
  const phaseLabels = {
    patient: isCommercial ? "Patient" : "Subject",
    hospital: isCommercial ? "Hospital" : "Site",
    investigator: isCommercial ? "HCP" : "Principal Investigator",
  };
  const reactToPrintFn = useReactToPrint({
    content: () => printContentRef.current,
  });
  
  const fetchPatientInfo = async (id = currentCycle?.qr_code_generation_id) => {
    try {
      if(!id) return
      if (window.qrGenerationTimeout) {
        clearTimeout(window.qrGenerationTimeout);
        window.qrGenerationTimeout = null;
      }
      const patientDetailsResponse = await dispatch(
        getPatientDetailsById({id:id, prodmfg:currentCycle?.product_manufacturing_id})
      ).unwrap();
      const patientDetails = patientDetailsResponse?.data?.patient_information;
      const isBagCount = patientDetailsResponse?.data?.number_of_bags;
      setBagCount(isBagCount || 0);
      setPhaseType(patientDetailsResponse?.data?.phase_type || '');
      if (patientDetails) {
        const patientBasicInfo = {
          patientName: patientDetails?.name || "-",
          phase_type: patientDetailsResponse?.data?.phase_type,
          patientInitials: patientDetails?.patient_initials,
          patientId: patientDetails?.patient_id || "-",
          hospital_patient_id: patientDetailsResponse?.data?.hospital_patient_id || "",
          id: patientDetails?.id,
          product_id:patientDetailsResponse?.data?.product_id,
          phase_id:patientDetails?.phase_id,
          inbond_form_id: patientDetails?.inbound_patient_id ?? null,
          logisticOperationId: patientDetailsResponse?.data?.logistics_operation_id ?? null,
          immunoactPatientId: patientDetails?.immunoact_patient_id || "-",
          qa_remarks: patientDetailsResponse?.data?.qa_remarks ?? ''
        };
      
        const patientMedicalRecord = {
          [`${phaseLabels.patient} Body Weight`]: `${patientDetails?.body_weight} kg` || "-",
          "Disease Indication": capitalizeWords(patientDetails?.disease) || "-",
          "Date of Birth": patientDetails?.dob
            ? moment(patientDetails.dob).format("DD/MM/YYYY")
            : "-",
              [`${phaseLabels.hospital} `]: patientDetails?.hospital || "-",
          [`${phaseLabels.hospital} ${phaseLabels.patient} ID`]: patientDetailsResponse?.data?.hospital_patient_id || "-",
          "Ship & Store": "2-8 degree celsius",
          "Total no Bags": patientDetailsResponse?.data?.no_of_bags || isBagCount || 0,
          "Batch ID": patientDetailsResponse?.data?.batch_no || "-",
        };
        setPatientData(patientDetailsResponse?.data)
        setPatientInfo(patientBasicInfo);
        setPatientMedicalInfo(patientMedicalRecord);
        setPrintPatientInfo(patientDetailsResponse?.data);

        // Generate QR code after a small delay to ensure it's rendered
        window.qrGenerationTimeout = setTimeout(() => {
          const canvas = qrRef.current?.querySelector('canvas');
          if (canvas) {
            const dataUrl = canvas.toDataURL('image/png');
            setQrCodeDataUrl(dataUrl);
          }
          // Clear the timeout reference after execution
          window.qrGenerationTimeout = null;
        }, 300);

      }
    } catch (error) {
      console.error("Error fetching patient info:", error);
    }
  };

useEffect(() => {
  if (currentCycle) {
    setPatientMedicalInfo((prev) => ({
      ...prev,
      "Total no Bags": currentCycle?.no_of_bags || 0,
      "Batch ID": currentCycle?.batch_no
    }));
  }
}, [currentCycle]);
  // function to get the timeline
  const getTimeLine = async (id) => {
    setTimeLineSkeletonLoading(true)
    try {
      await dispatch(
        fetchV2V({ portal_type: 2, patient_id: id ?? patientInfo?.id })
      ).unwrap();
      await fetchPatientInfo();
    }
    catch (err) {
      console.error(err);
    }
    finally {
      setTimeLineSkeletonLoading(false)
    }
  };

  const handlePrint = async (value) => {

    // Clear any existing timeout to prevent multiple print triggers
    if (printTimeoutRef.current) {
      clearTimeout(printTimeoutRef.current);
    }
    let count = 1;
    let singleBag = null;

    if (value?.bag_no) {
      count = 1;
      singleBag = value?.bag_no;
    } else {
      count = value?.bags || bagCount;
      singleBag = null;
    }
    setPrintCount(count);
    setPrintSingleBag(singleBag);
    getTimeLine();
    fetchPatientInfo();
    // Prepare print data
    const printData = {
      printPatientInfo,
      qrCodeDataUrl,
      bagCount,
      printCount: count,
      printSingleBag: singleBag,
      patientMedicalInfo,
      phaseType,
      phaseLabels, 
    };
    setPrintData(printData);
    // Trigger print after state update
    printTimeoutRef.current = setTimeout(() => {
      reactToPrintFn();
      // Clear the timeout reference after execution
      printTimeoutRef.current = null;
    }, 100);
  };
  useEffect(() => {
    if (printPatientInfo?.patient_information?.id) {
      getTimeLine();
    }
  }, [printPatientInfo?.patient_information?.id]);

  // function to mark lsm as recieved
  const handleRecieveLSM = async () => {
    try {
      const res = await dispatch(
        recieveLSM({ id: patientInfo?.logisticOperationId, feasibility_assessments_id: currentCycle?.feasibility_assessments_id })
      ).unwrap();
      if (res?.status == 200) {
        getTimeLine();
      }
    }
    catch (err) {
      console.error(err);
    }
  }

  // function to handle when LSM is marked shipped
  const handleLSMMarkedShipped = () => {
    getTimeLine();
    fetchPatientInfo();
  }

    useEffect(() => {
      if(ids){
    fetchPatientInfo(ids);
    setIds('')
      }
  }, [ids]);
  
  useEffect(() => {
    if(!ids)
      fetchPatientInfo()
  },[currentCycle?.product_manufacturing_id])

  // Get Timeline when component mounts
  useEffect(() => {
    const patientId = patientInfo?.id
    if (patientId)
      getTimeLine(patientId)
  }, [patientInfo?.id])

  useEffect(() => {
    if (
      hasAuthority(
        ["in-bound-marked-shipped", "in-bound-marked-received"],
        bmr_permissions
      )
    ) {
      dispatch(setSlugs(["lsm-shipped", "lsm-received"]));
    }
    return () => {
      dispatch(setSlugs([""]));
    };
  }, []);
  ////////// phase and pantient List for chat bot ///////////

  useEffect(() => {
    const phaseList = [{ value: patientData?.patient_information?.phase_id, label: `${patientData?.phase_name} (${patientData?.product_name})`, patient_id: patientData?.patient_information?.id }]
    const patientList = [{ value: patientData?.patient_information?.id, label: `${patientData?.patient_information?.name}`, phase_id: patientData?.patient_information?.phase_id }]
    dispatch(addPatientList(patientList))
    dispatch(addPhaseList(phaseList))
  }, [patientData])

  const shouldRenderOutboundForm =
    hasAuthority(["outbound-patient-view"], bmr_permissions)
    && !excludedPaths.some(path => location?.pathname.includes(path))
    && allInitialSteps?.find(item => item.slug === 'qa-review' && item.status === 2)
  ////////////////////////////////////////////////////////////


  return (
    <Box>

      <Box container className="mt-4 ml-3 mr-3 mainDiv">
        <BreadCrumb BreadCrumbsListing={breadCrumbArray} />
        <LmsKitLabel
          screenType={['superadmin', 'logistics-management']?.includes(role_slug) ? 'qr-code' : "logistics"}
          patientInfo={patientInfo}
          bagCount={bagCount}
          patientMedicalInfo={patientMedicalInfo}
          qrCodeId={id}
          handlePrint={handlePrint}
          getTimeLine={getTimeLine}
          phaseType={phaseType}       
          phaseLabels={phaseLabels} 
        />
      </Box>

      <Box container className="mt-4 ml-3 mr-3 pb-3 mainDiv">
       <ProgressTracker
    FormComponent={MarkAsShippedForm}
    buttonPop={bagCount > 0 ? ['lsm-shipped', 'lsm-received-bmr'] : ['lsm-received-bmr']}
    steps={allInitialSteps}
    patient_id={patientData?.patient_information?.id}
    onAction={handleRecieveLSM}
    onUpdate={handleLSMMarkedShipped}
  />

  {timeLineSkeletonLoading && (
    <Box position="absolute" top={0} left={0} right={0}>
      <SkeletonLoader rowCount={1} height={80} isTable={false} />
    </Box>
  )}
      </Box>

      {shouldRenderOutboundForm && (
        <Box className="mt-4 ml-3 mr-3 pb-3">
          {loading ? (
            <SkeletonLoader rowCount={1} height={80} isTable={false} />
          ) : (
            <OutBondForm
              updateTimeLine={getTimeLine}
              printPatientInfo={printPatientInfo}
              subjectId={patientData?.patient_information?.id}
            />
          )}
        </Box>
      )}
      {patientInfo?.inbond_form_id && (
        <Box className="mt-4 ml-3 mr-3 pb-3">
          {loading ? (
            <SkeletonLoader rowCount={1} height={80} isTable={false} />
          ) : (
            <InBoundForm patientData={
              {
                ...patientInfo,
                ...patientData,
                qrCode_id: currentCycle?.qr_code_generation_id || id,
                feasibility_assessments_id: currentCycle?.feasibility_assessments_id,
                inbond_form_id: currentCycle?.inbond_patients_id,
                patient_id: patientData?.patient_information?.id,
              }}
               printPatientInfo={printPatientInfo}
              initialSteps={allInitialSteps}
              updateTimeLine={getTimeLine}
            />
          )}
        </Box>
      )}
      {printData && (
        <div style={{ display: "none" }}>
          <QrPrintContent
            ref={printContentRef}
            printData={printData}
          />
        </div>
      )}

     

      <ChatModule />
    </Box>
  );
};

export default InBoundView;
